import { createFormHook, revalidateLogic } from "@tanstack/react-form";
import {
  AvailabilitySlotPicker,
  BookingAdvanceLimitField,
  BookingLimitField,
  DatePickerField,
  DateRangeField,
  DayOfWeekField,
  DurationField,
  IcdCodeField,
  LoincCodeField,
  MedicationField,
  OptionalDurationField,
  PatientField,
  PractitionerField,
  PropertyPickerCalendarField,
  PropertyPickerCommandField,
  PropertyPickerListField,
  RichTextField,
  ServiceTypeField,
  TimeRangeField,
  TimezoneField,
  TogglePillField,
  VisitTypeField,
} from "@/shared/forms/fields";
import {
  DateField,
  FormActions,
  InputField,
  MultiOptionGroupField,
  NumberField,
  OptionGroupField,
  SelectField,
  StringNumberField,
  SubmitButton,
  SwitchField,
  SwitchListField,
  TextareaField,
  TimePickerField,
} from "./connected-fields";
import { focusFirstInvalid } from "./focus-first-invalid";
import { fieldContext, formContext } from "./form-context";

const appForm = createFormHook({
  fieldComponents: {
    // Connected fields
    InputField,
    MultiOptionGroupField,
    NumberField,
    StringNumberField,
    OptionGroupField,
    SelectField,
    TextareaField,
    SwitchField,
    SwitchListField,
    DateField,
    TimePickerField,
    // Property pickers (form-field wrappers)
    PropertyPickerListField,
    PropertyPickerCalendarField,
    PropertyPickerCommandField,
    DatePickerField,
    TogglePillField,
    // Rich text
    RichTextField,
    // Domain fields
    AvailabilitySlotPicker,
    DurationField,
    IcdCodeField,
    LoincCodeField,
    MedicationField,
    OptionalDurationField,
    BookingAdvanceLimitField,
    BookingLimitField,
    PatientField,
    PractitionerField,
    ServiceTypeField,
    TimezoneField,
    DayOfWeekField,
    TimeRangeField,
    DateRangeField,
    VisitTypeField,
  },
  formComponents: { FormActions, SubmitButton },
  fieldContext,
  formContext,
});

export const { withForm, withFieldGroup } = appForm;

/**
 * Forms stay quiet until the first submit, then re-check live so an error clears as it is fixed.
 * Register a form's schema under `validators.onDynamic` for this to apply.
 */
export const useAppForm: typeof appForm.useAppForm = (options) =>
  appForm.useAppForm({
    validationLogic: revalidateLogic(),
    onSubmitInvalid: () => focusFirstInvalid(),
    ...options,
  });
